import React, { useEffect, useState, useRef, useMemo } from "react"
import { withRouter, Link } from "react-router-dom"
import { Card, CardBody, Col, Row, Button, Label, UncontrolledTooltip } from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import Select from "react-select"
import Switch from "react-switch"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { isEmpty, map } from "lodash"
import moment from "moment"
// Import scss
import "../../assets/scss/custom.scss"
//redux
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { messageTitle } from "constants/common";
import OffSymbol from "components/Common/OffSymbol"
import OnSymbol from "components/Common/OnSymobl"

import {
  getSessionTickets as onGetSessionTickets,
  getExportSessionTickets,
  resetExportFileData,
  clearMessage,
} from "../../store/tickets/actions"

const sizePerPage = 25;
const defaultStartDate = moment().startOf("M")
const defaultEndDate = moment()
import { dateformat } from "config"


const CarparkTicketList = props => {
  const dispatch = useDispatch()
  const [fileType, setFileType] = useState({ label: "PDF", value: "pdf" });

  const [startDate, setStartDate] = useState(
    defaultStartDate.format(dateformat.default)
  )
  const [endDate, setEndDate] = useState(
    defaultEndDate.format(dateformat.default)
  )
  const [currentPage, setCurrentPage] = useState(1);
  const { sessionTicketList, file, message, pagination, error } = useSelector(
    state => ({
      sessionTicketList: state.sessionTickets.sessionTicketList,
      pagination: state.sessionTickets.pagination,
      message: state.sessionTickets.message,
      error: state.sessionTickets.error,
      file: state.sessionTickets.file,
    })
  )

  const [searchKey, setSearchKey] = useState("");
  const [showUserOnly, setShowUserOnly] = useState("true");
  const [filteredRes, setFilteredRes] = useState([]);

  const spListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      formatter: record => <>{record._id}</>,
    },
    {
      text: "Session ID",
      dataField: "ticketId",
      sort: true,
    },
    {
      text: "User ID / Guest ID",
      dataField: "userId",
      sort: true,
      formatter: (cellContent, record) => {
        return record?.guest?.guestId || record?.userId?.userId || "-"
      },
    },
    {
      text: "Name",
      dataField: "name",
      sort: true,
      formatter: (cellContent, record) => {
        return record?.guest?.guestName || record?.userId?.name || "-"
      },
    },
    // {
    //   text: "Role",
    //   dataField: "roleTitle",
    //   sort: true,
    //   formatter: (cellContent, record) => {
    //     return record?.user?.role?.roleTitle || "-"
    //   },
    // },
    // {
    //   text: "Season",
    //   dataField: "seasonTitle",
    //   sort: true,
    //   formatter: (cellContent, record) => {
    //     return record?.user?.season?.seasonTitle || "-"
    //   },
    // },
    {
      text: "Carpark",
      dataField: "carpark",
      sort: true,
    },
    {
      text: "Vehicle Details",
      dataField: "carplate",
      sort: true,
    },
    // {
    //   text: "Driver ID",
    //   dataField: "ticketDescription",
    //   sort: true,
    // },
    {
      text: "Entry Date Time",
      dataField: "entryTime",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <>
            {record.entryTime
              ? moment(record.entryTime).format("Do MMM YYYY, h:mm a")
              // ?  moment(moment(moment.utc(record.seasonStart).subtract(8,"h")).local()).format("Do MMM YYYY, h:mm a")  
              : "No Entry Date"}
          </>
        )
      },
    },
    {
      text: "Exit Date Time",
      dataField: "carparkDate",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <>
            {record.carparkDate
              ? moment(record.carparkDate).format("Do MMM YYYY, h:mm a")
              // ?  moment(moment(moment.utc(record.seasonEnd).subtract(8,"h")).local()).format("Do MMM YYYY, h:mm a")  
              : "Open Session"}
          </>
        )
      },
    },
  ]
  var node = useRef()

  // Used for searchBar
  // var searchRef = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  useEffect(() => {
    if (sessionTicketList) {
      setFilteredRes(sessionTicketList);
    }
  }, [sessionTicketList]);

  useEffect(() => {
    if (searchKey.length >= 2 || searchKey == "") {
      setCurrentPage(1);
      dispatch(onGetSessionTickets({ size: sizePerPage, search: searchKey, startDate: startDate, endDate: endDate, showUserOnly }));
    }
  }, [searchKey]);
  useEffect(() => {
    setCurrentPage(1);
    dispatch(onGetSessionTickets({ size: sizePerPage, search: searchKey, startDate: startDate, endDate: endDate, showUserOnly }));
  }, [showUserOnly]);

  useEffect(() => {
    dispatch(onGetSessionTickets({ page: currentPage, size: sizePerPage, search: searchKey, startDate: startDate, endDate: endDate, showUserOnly }));
  }, [currentPage]);

  /*   useEffect(() => {
      //console.log('test======================> 1');
      dispatch(
        onGetSessionTickets({
          size: sizePerPage,
          startDate: startDate,
          endDate: endDate,
          search: searchKey,
        })
      )
    }, []); */


  useEffect(() => {
    if (file) {
      // Call to download file
      handleExport(file)
      setTimeout(() => {
        dispatch(resetExportFileData())
      }, 300)
    }
  }, [file]);

  useEffect(() => {
    if (message) {
      message == "PDF file content not found." ||
        message == "Failed to export invalid file type."
        ? toastr.error(message, messageTitle)
        : toastr.success(message, messageTitle)
      // dispatch(onGetSessionTickets())
      setTimeout(() => {
        dispatch(clearMessage())
      }, 300)
    }
  }, [dispatch, message]);

  useEffect(() => {
    if (!isEmpty(error)) {
      toastr.error(error.message, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [error]);

  const pageOptions = {
    page: currentPage,
    sizePerPage: sizePerPage,
    totalSize: pagination ? pagination?.totalItems : sessionTicketList?.length || 0,
    custom: true,
    totalPages: pagination ? pagination?.totalPages : 1,
    onPageChange: setCurrentPage,
  }

  const setDownloadType = () => {
    console.log('sessionTicketList', filteredRes);
    let exportPayload = {
      file_type: fileType.value,
      search: searchKey, startDate: startDate, endDate: endDate,
    }
    dispatch(getExportSessionTickets(exportPayload))
  }

  const handleExport = fileData => {
    const fileName =
      `session_tickets_` +
      new Date().getTime() +
      `.${fileType.value.toLowerCase()}`
    const downloadType =
      fileType.value == "csv" || fileType.value == "xlsx"
        ? // ? "application/vnd.ms-excel"
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        : "application/pdf"
    const base64data = `data:${downloadType};base64,${fileData}`
    const downloadLink = document.createElement("a")
    downloadLink.href = base64data
    downloadLink.download = fileName
    downloadLink.click()
    return fileName
  }

  const handleSelectType = e => {
    setFileType(e)
  }

  useEffect(() => {
    let payload = {
      size: sizePerPage,
      search: searchKey,
      showUserOnly,
    }
    if (startDate && endDate) {
      payload = {
        ...payload,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
      }
    }
    dispatch(onGetSessionTickets(payload))
  }, [startDate, endDate])

  const handleReset = e => {
    setStartDate(defaultStartDate.format(dateformat.default))
    setEndDate(defaultEndDate.format(dateformat.default))
    setSearchKey("")
    setShowUserOnly(true)
    dispatch(
      onGetSessionTickets({
        size: sizePerPage,
        startDate: defaultStartDate.format(dateformat.default),
        endDate: defaultEndDate.format(dateformat.default),
        search: "",
        showUserOnly
      })
    )
  }

  const defaultSorted = [
    {
      dataField: "createdAt", // if dataField is not match to any column you defined, it will be ignored.
      order: "desc", // desc or asc
    },
  ]

  const fileTypeOptions = [
    {
      label: "PDF",
      value: "pdf",
    },
    {
      label: "CSV",
      value: "csv",
    },
    {
      label: "XLSX",
      value: "xlsx",
    },
  ]

  const keyField = "_id"

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No data to display</p>
  }

  const handleTableChange = () => { }
  /*   const handleTableChange = (tData) => {
      console.log('tData', tData);
      return tData;
    } */

  // Below function is used for searchBar
  // const handleAfterSearch = (searchedData) => {
  //   setSearched(searchedData);
  // }

  // Below function is used for searchBar
  // useEffect(()=>{
  //   if(searchRef.current.state.value){
  //     setFilteredRes(searched);
  //   }else{
  //     setFilteredRes(sessionTicketList);
  //   }
  // },[searched]);

  return (
    <React.Fragment>
      {/* <Spinner loading={isLoading} /> */}
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField={keyField}
                columns={spListColumns}
                data={filteredRes || []}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return (
                    <ToolkitProvider
                      keyField={keyField}
                      data={filteredRes || []}
                      columns={spListColumns}
                      bootstrap4
                      search // if using searchBar, delete this line and uncomment below line
                    // search={ {afterSearch: (newResult) => handleAfterSearch(newResult)} }
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col md="2">
                              <input
                                className="form-control"
                                type="date"
                                value={startDate}
                                id="startDate"
                                name="startDate"
                                onChange={e => setStartDate(e.target.value)}
                                onBlur={e => setStartDate(e.target.value)}
                              />
                            </Col>
                            <Col md="2">
                              <input
                                className="form-control"
                                type="date"
                                value={endDate}
                                id="endDate"
                                name="endDate"
                                onChange={e => setEndDate(e.target.value)}
                                onBlur={e => setEndDate(e.target.value)}
                              />
                            </Col>
                            <Col md="1">
                              <Button
                                color="primary"
                                className="font-16 btn-block btn btn-primary"
                                onClick={e => {
                                  toolkitProps.searchProps.onSearch("")
                                  setTimeout(() => {
                                    handleReset(e)
                                  }, 200)
                                }}
                              >
                                Reset
                              </Button>
                            </Col>
                            {/* <Col md={2}>
                              <Label className="form-check-label">
                                Hide Unknown
                              </Label>
                              <Switch
                                checked={showUserOnly}
                                onColor="#626ed4"
                                onChange={e => {
                                  setShowUserOnly(!showUserOnly)
                                }}
                                uncheckedIcon={
                                  <OffSymbol text="Off" />
                                }
                                checkedIcon={
                                  <OnSymbol text="On" />
                                }
                              />
                            </Col> */}
                            <Col md="3">
                              <div className="search-box ms-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  {/* <SearchBar {...toolkitProps.searchProps} ref={searchRef} />
                                  <i className="bx bx-search-alt search-icon" /> */}
                                  <input
                                    id="search-bar-0"
                                    type="text"
                                    className="form-control "
                                    placeholder="Search"
                                    value={searchKey}
                                    onChange={e => setSearchKey(e.target.value)}
                                  />

                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                            <Col md="2">
                              <div
                                className="text-sm-end"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <div style={{ width: 100 }} className="me-2">
                                  <Select
                                    placeholer={"Select Type"}
                                    name={"fileType"}
                                    value={fileType}
                                    onChange={e => {
                                      handleSelectType(e)
                                    }}
                                    options={fileTypeOptions}
                                    classNamePrefix="select2-selection me-2"
                                  />
                                </div>
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={() => setDownloadType()}
                                >
                                  <i className="bx bx-upload me-1" />
                                  Export
                                </Button>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  remote
                                  keyField={keyField}
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  defaultSorted={defaultSorted}
                                  classes={
                                    "table align-middle table-nowrap table-hover"
                                  }
                                  bordered={false}
                                  striped={false}
                                  responsive
                                  ref={node}
                                  noDataIndication={emptyDataMessage}
                                  onTableChange={handleTableChange}
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row className="align-items-md-center mt-30">
                            <Col className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  )
                }}
              </PaginationProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default withRouter(CarparkTicketList)

